/**
 * Enhanced URL validation utility
 * Supports complex URLs including query parameters, hyphens, UUIDs, and modern URL patterns
 */
export const validateUrl = (url: string): boolean => {
  if (!url) return false;
  
  try {
    // Primary validation using URL constructor - handles all standard URL formats
    new URL(url.startsWith('http') ? url : `https://${url}`);
    return true;
  } catch {
    // Fallback to enhanced regex for more permissive validation
    const urlRegex = /^(https?:\/\/)?([\da-z.-]+\.)+[a-z]{2,}(\/[^\s]*)?$/i;
    return urlRegex.test(url);
  }
};

/**
 * Validates multiple URLs and returns validation results
 */
export const validateUrls = (urls: string[]): boolean[] => {
  return urls.map(validateUrl);
};

/**
 * Checks if a URL is valid and returns error message if not
 */
export const getUrlValidationError = (url: string, fieldName: string = 'URL'): string | null => {
  if (!url) return null; // Empty URLs are handled by required field validation
  
  if (!validateUrl(url)) {
    return `Please enter a valid ${fieldName}`;
  }
  
  return null;
};